import React from 'react';
import { Link } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';

export const NotFound: React.FC = () => {
  return (
    <div className="min-h-screen pt-20 flex items-center justify-center bg-white px-6">
      <div className="text-center max-w-md">
        <div className="relative w-48 h-48 mx-auto mb-8">
            {/* Abstract visual for broken connection */}
            <div className="absolute inset-0 bg-blue-50 rounded-full animate-pulse"></div>
            <div className="absolute inset-4 bg-white rounded-full flex items-center justify-center text-6xl font-bold text-primary/20">404</div>
            <div className="absolute bottom-0 right-0 bg-primary text-white p-4 rounded-full shadow-lg">
                <div className="w-8 h-1 bg-white rounded-full transform rotate-45"></div>
                <div className="w-8 h-1 bg-white rounded-full transform -rotate-45 -mt-1"></div>
            </div>
        </div>
        
        <h1 className="text-4xl font-bold text-secondary mb-4">Page Not Found</h1>
        <p className="text-gray-500 text-lg mb-8 leading-relaxed">
          The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link 
                to="/" 
                className="inline-flex items-center justify-center gap-2 bg-primary text-white px-8 py-3.5 rounded-full font-bold hover:bg-primary-light transition-all shadow-lg hover:-translate-y-1"
            >
                <Home size={18} />
                Back to Home
            </Link>
            <button 
                onClick={() => window.history.back()}
                className="inline-flex items-center justify-center gap-2 bg-gray-50 text-secondary border border-gray-200 px-8 py-3.5 rounded-full font-bold hover:bg-gray-100 transition-all"
            >
                <ArrowLeft size={18} />
                Go Back
            </button>
        </div>
      </div>
    </div>
  );
};